export const compactPreferenceList = value => {
  if (Array.isArray(value)) {
    return value.map(item => item?.toString().trim()).filter(Boolean);
  }

  return (
    value
      ?.toString()
      .split(',')
      .map(item => item.trim())
      .filter(Boolean) || []
  );
};

export const preferenceValueToInput = value => {
  if (Array.isArray(value)) return compactPreferenceList(value).join(', ');
  if (value && typeof value === 'object') {
    return Object.entries(value)
      .filter(([, itemValue]) => itemValue?.toString().trim())
      .map(([key, itemValue]) => `${key}: ${itemValue}`)
      .join(', ');
  }
  return value?.toString() || '';
};

/**
 * Builds ComboBox-compatible options from the account preference definition.
 * @param {Object} definition - Contact preference definition returned by the API.
 * @returns {Array<{label: string, value: string}>} selectable option rows.
 */
export const preferenceDefinitionOptions = definition =>
  (definition.options || []).map(option => ({
    label: option,
    value: option,
  }));

/**
 * Converts a persisted preference value to an editable form value for its type.
 * @param {Object} definition - Contact preference definition metadata.
 * @param {*} value - Persisted JSONB preference value.
 * @returns {string|string[]} value expected by the relevant form control.
 */
export const preferenceValueForDefinition = (definition, value) => {
  if (['list', 'list_with_custom'].includes(definition.field_type)) {
    return compactPreferenceList(value);
  }

  return preferenceValueToInput(value);
};

export const normalizePreferenceValue = value => {
  if (Array.isArray(value)) return compactPreferenceList(value);

  return value?.toString().trim() || '';
};

export const buildPreferencesPayload = (definitions, values) =>
  definitions.reduce((payload, definition) => {
    payload[definition.key] = normalizePreferenceValue(values[definition.key]);
    return payload;
  }, {});

export const preferencesFromRows = rows =>
  (rows || []).reduce((result, row) => {
    result[row.key] = preferenceValueForDefinition(row, row.value);
    return result;
  }, {});

export const formatPreferenceValue = value => {
  if (Array.isArray(value)) return compactPreferenceList(value).join(', ');
  if (value && typeof value === 'object') {
    return Object.values(value).filter(Boolean).join(', ');
  }
  return value?.toString() || '';
};
